import React, { useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TableSortLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { formatPhoneNumber } from "../../utils/FormatPhone";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const formatDate = (date) =>
  format(new Date(date), "dd/MM/yyyy", { locale: ptBR });

const descendingComparator = (a, b, orderBy) => {
  let aValue = a[orderBy] || "";
  let bValue = b[orderBy] || "";

  // Forçar string, remover acentos, e lowercase
  aValue = String(aValue)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  bValue = String(bValue)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  if (bValue < aValue) return -1;
  if (bValue > aValue) return 1;
  return 0;
};

const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const ClientTable = ({ clients, onEdit }) => {
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedClients = useMemo(() => {
    return [...clients].sort(getComparator(order, orderBy));
  }, [clients, order, orderBy]);

  return (
    <div className="flex flex-col">
      <p></p>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sortDirection={orderBy === "name" ? order : false}>
                <TableSortLabel
                  active={orderBy === "name"}
                  direction={orderBy === "name" ? order : "asc"}
                  onClick={() => handleRequestSort("name")}
                >
                  Nome
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "email" ? order : false}
              >
                <TableSortLabel
                  active={orderBy === "email"}
                  direction={orderBy === "email" ? order : "asc"}
                  onClick={() => handleRequestSort("email")}
                >
                  Email
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">Contato</TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "address" ? order : false}
              >
                <TableSortLabel
                  active={orderBy === "address"}
                  direction={orderBy === "address" ? order : "asc"}
                  onClick={() => handleRequestSort("address")}
                >
                  Endereço
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "createdAt" ? order : false}
              >
                <TableSortLabel
                  active={orderBy === "createdAt"}
                  direction={orderBy === "createdAt" ? order : "asc"}
                  onClick={() => handleRequestSort("createdAt")}
                >
                  Data de Cadastro
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clients.map((client) => (
              <TableRow key={client.id}>
                <TableCell>{client.name}</TableCell>
                <TableCell align="center">{client.email}</TableCell>
                <TableCell align="center">
                  {formatPhoneNumber(client.phone)}
                </TableCell>
                <TableCell
                  align="center"
                  width={400}
                  className="whitespace-normal break-words"
                >
                  {client.address
                    ? `${client.address}`
                    : "Sem Endereço Cadastrado"}
                </TableCell>
                <TableCell align="center">
                  {formatDate(client.createdAt)}
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => onEdit(client)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ClientTable;
